import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";
import { LapellandCustomerOrderFilterComponents } from "src/tenantCustomizations/tenants/lapelland/LapellandCustomerOrderFilterComponents.tsx";

export const lapellandCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			accountingIntegrationEnabled: true,
			customerOfferContractPrintoutEnabled: true,
			customerOfferContractSigningEnabled: false,
			reclamationsEnabled: true,
			configuratorEnabled: true,
			defaultCustomerType: "CONSUMER",
			surveysEnabled: true,
			inputPricesWithVatByDefault: true,
			billingPlanEnabledByDefault: true,
			reclamationRoundPlanningAiEnabled: true,
			transportPlanningEnabled: true,
			vectorEmbeddingsEnabled: true,
			shopOrderTaskStatusInProductionPlanningEnabled: true,
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
	],
	erp: {
		sales: {
			customerOrderDataGridExtraFilterComponents: LapellandCustomerOrderFilterComponents,
		},
	},
};
